// extracted by mini-css-extract-plugin
export default {"root":"SideListItem_root__q4WEa","active":"SideListItem_active__iCaXe"};